import {resources} from "../../../../../../../core/models/resource/resources";

export const uspResourceType = resources['usp'];
export const productValuesResourceType = resources['product-values'];
export const productDescriptionsResourceType = resources['product-descriptions'];
export const productUsageRulesResourceType = resources['product-usage-rules'];
export const websiteBackupsResourceType = resources['website-backups'];
export const marketingDraftsResourceType = resources['marketing-drafts'];
export const websiteBackupFilesResourceType = resources['website-backup-files'];

export const modalPath: Record<string, string> = {
  usp: uspResourceType.path,
  productValues: productValuesResourceType.path,
  productDescriptions: productDescriptionsResourceType.path,
  productUsageRules: productUsageRulesResourceType.path,
  websiteBackups: websiteBackupsResourceType.path,
  marketingDrafts: marketingDraftsResourceType.path
};

export const titleModal: Record<string, string> = {
  usp: uspResourceType.name,
  productValues: productValuesResourceType.name,
  productDescriptions: productDescriptionsResourceType.name,
  productUsageRules: productUsageRulesResourceType.name,
  websiteBackups: websiteBackupsResourceType.name,
  marketingDrafts: marketingDraftsResourceType.name
};

export const modalFilePath: Record<string, string> = {
  websiteBackups: websiteBackupFilesResourceType.path
}
